// src/pages/empleos/AplicarParaEmpleo.jsx
import { useState, useEffect, useContext } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowLeft } from "react-icons/fa";
import "./empleosaplicados.css";

function EmpleosAplicados() {
  const { user } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Obtenemos el jobId de la URL
  const jobId = searchParams.get("jobId");

  const [job, setJob] = useState(null);
  const [coverLetter, setCoverLetter] = useState("");
  const [notes, setNotes] = useState("");

  useEffect(() => {
    // Simulación: carga el empleo desde localStorage
    const storedJobs = JSON.parse(localStorage.getItem("jobs")) || [];
    const found = storedJobs.find((j) => j.id.toString() === jobId);
    setJob(found || null);
  }, [jobId]);

  // Solo los usuarios pueden aplicar
  if (!user || user.userType !== "user") {
    return (
      <div className="register-container">
        <div className="register-card">
          <p>Acceso denegado. Debes ser un usuario para aplicar.</p>
        </div>
      </div>
    );
  }

  const handleApply = (e) => {
    e.preventDefault();

    // Obtenemos la lista global de aplicaciones
    const storedApplications = JSON.parse(localStorage.getItem("applications")) || [];

    // Verificamos si el usuario ya aplicó a este empleo
    const alreadyApplied = storedApplications.find(
      (ap) => ap.jobId === job.id && ap.applicantId === user.id
    );
    if (alreadyApplied) {
      alert("Ya has aplicado a este empleo.");
      return;
    }

    // Creamos el objeto de aplicación
    const newApplication = {
      jobId: job.id,
      applicantId: user.id,
      titulo: job.title,
      estado: "En proceso",
      coverLetter,
      notas: notes,
      verCompletoLink: `/detalle-empleo/${job.id}`,
      dateApplied: new Date().toLocaleDateString(),
    };

    storedApplications.push(newApplication);
    localStorage.setItem("applications", JSON.stringify(storedApplications));

    alert("¡Solicitud enviada correctamente!");
    navigate("/mi-cuenta/empleos-aplicados");
  };

  return (
    <div className="register-container">
      <div className="register-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={() => navigate("/mi-cuenta")}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>

        {/* Título */}
        <h2 className="register-title">
          Aplicar para: {job ? job.title : "Cargando..."}
        </h2>

        {job && (
          <form className="apply-form" onSubmit={handleApply}>
            <div className="form-group">
              <label>Carta de Presentación (opcional)</label>
              <textarea
                className="form-control"
                rows="4"
                value={coverLetter}
                onChange={(e) => setCoverLetter(e.target.value)}
                placeholder="Escribe aquí tu carta de presentación"
              />
            </div>
            <div className="form-group">
              <label>Notas (opcional)</label>
              <textarea
                className="form-control"
                rows="2"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Alguna nota adicional"
              />
            </div>

            <button type="submit" className="btn-apply-now">
              Aplicar Ahora
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default EmpleosAplicados;